import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class GridRouterLinkComponent extends Vue {
    @Prop() public text: string;
    @Prop({default: ''}) public url: string;
}
